import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { WixStyleParamsProvider } from '@wix/editor-settings';

import i18n from '../../config/i18n';
import { GroupsActionsProvider } from '../../contexts/GroupsActionsContext';
import { GroupsProvider } from '../../contexts/GroupsContext';

import { App } from './App';
import { AppRootProps } from './types';

const ApplicationRoot: React.FC<AppRootProps> = ({
  locale,
  experiments,
  groups,
  isGroupCreating,
  isUserLoggedIn,
  actions,
  styleParams,
}) => (
  <I18nextProvider i18n={i18n(locale)}>
    <ExperimentsProvider options={{ experiments }}>
      <WixStyleParamsProvider styleParams={styleParams}>
        <GroupsProvider
          value={{
            groups,
            isGroupCreating,
          }}
        >
          <GroupsActionsProvider value={actions}>
            <App isUserLoggedIn={isUserLoggedIn} />
          </GroupsActionsProvider>
        </GroupsProvider>
      </WixStyleParamsProvider>
    </ExperimentsProvider>
  </I18nextProvider>
);

export default ApplicationRoot;
